import { IconArrow } from '@/assets/icons/IconArrow';
import styles from './emailHandoffProgress.module.scss';

const steps = ['Account', 'Payment', 'Review'];

export function EmailHandoffProgress() {
    return (
        <ol className={styles.progress} aria-label="Sign-up progress">
            {steps.map((step, index) => (
                <li key={step} aria-current={index === 0 ? 'step' : undefined}>
                    <span>{step}</span>
                    {index < steps.length - 1 && (
                        <span aria-hidden="true">
                            <IconArrow />
                        </span>
                    )}
                </li>
            ))}
        </ol>
    );
}
